import { useMobileDesign } from 'hooks/useMobileDesign';

import styles from './NavMenu.module.scss';
import HamburgerMenu from './components/HamburgerMenu/HamburgerMenu';
import HorizontalMenu from './components/HorizontalMenu/HorizontalMenu';
import menuConfig from './utils/menuConfig';

const NavMenu = () => {
  const isMobile = useMobileDesign();

  return (
    <div className={styles.navMenu}>
      <div className={styles.navLeft}>
        <HamburgerMenu items={menuConfig} />
      </div>

      {!isMobile && (
        <div className={styles.navRight}>
          <HorizontalMenu items={menuConfig} />
        </div>
      )}
    </div>
  );
};

export default NavMenu;
